/* Careatic — hero slider (ported from Header.jsx Hero).
   2+ slides, autoplay (default 6s), pause on hover, dots + desktop arrows.

   Video loading: ca-hero.liquid intentionally emits <video> with NO src and no
   autoplay. The browser's preload scanner races ahead of this script, so the
   old approach — render every slide's video, then strip src here — still paid
   for the bytes (12.4MB of 1080p on mobile). Instead we attach a rendition
   matched to the viewport (480p mobile / 720p desktop) for the ACTIVE slide
   only, after load, and skip video entirely on Save-Data or 2G.

   Mobile (<=767px): shows ONLY the first slide.
   Fires a single view_item_list per slide change. */
(function () {
  'use strict';

  var mqMobile = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;

  function wantsLightPage() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    if (c.saveData) return true;
    return /(^|-)2g$/.test(c.effectiveType || '');
  }

  function attach(slide) {
    if (!slide || wantsLightPage()) return;
    var v = slide.querySelector('[data-ca-hero-video]');
    if (!v || v.dataset.caAttached) return;
    var isMobile = mqMobile && mqMobile.matches;
    var url = isMobile ? v.getAttribute('data-src-sd') : v.getAttribute('data-src-hd');
    if (!url) url = v.getAttribute('data-src-hd') || v.getAttribute('data-src-sd');
    if (!url) return;
    v.dataset.caAttached = '1';
    v.muted = true;
    v.preload = 'auto';
    v.src = url;
    try { v.load(); } catch (e) {}
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function pauseOthers(slides, active) {
    slides.forEach(function (s) {
      if (s === active) return;
      var v = s.querySelector('[data-ca-hero-video]');
      if (v && !v.paused) { try { v.pause(); } catch (e) {} }
    });
  }

  function whenIdle(fn) {
    function run() {
      if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 2000 });
      else setTimeout(fn, 200);
    }
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run);
  }

  function setup(root) {
    if (root.dataset.caBound) return;
    root.dataset.caBound = '1';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ca-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ca-hero-dot]'));
    var isMobile = mqMobile && mqMobile.matches;
    if (isMobile && slides.length > 1) {
      slides.slice(1).forEach(function (s) {
        s.style.display = 'none';
        s.setAttribute('aria-hidden', 'true');
      });
      dots.slice(1).forEach(function (d) { d.style.display = 'none'; });
      slides = slides.slice(0, 1);
      dots = dots.slice(0, 1);
    }
    if (slides.length === 0) return;
    var interval = parseInt(root.dataset.interval || '6000', 10);
    var i = 0, paused = false, timer;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.setAttribute('data-active', k === i);
        s.setAttribute('aria-hidden', k !== i);
      });
      dots.forEach(function (d, k) { d.setAttribute('data-active', k === i); });
      pauseOthers(slides, slides[i]);
      attach(slides[i]);
      if (window.caTrack) window.caTrack('view_item_list', { item_list_id: 'hero', slide: i + 1 });
    }
    function next() { show(i + 1); }
    function start() { if (slides.length > 1) timer = setInterval(function () { if (!paused) next(); }, interval); }

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    var prev = root.querySelector('[data-ca-hero-prev]');
    var nxt = root.querySelector('[data-ca-hero-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (nxt) nxt.addEventListener('click', function () { show(i + 1); });

    // Mark slide 1 active immediately, but hold its video until the page has
    // finished loading so it never competes with LCP.
    slides.forEach(function (s, k) {
      s.setAttribute('data-active', k === 0);
      s.setAttribute('aria-hidden', k !== 0);
    });
    dots.forEach(function (d, k) { d.setAttribute('data-active', k === 0); });
    if (window.caTrack) window.caTrack('view_item_list', { item_list_id: 'hero', slide: 1 });
    whenIdle(function () { attach(slides[0]); });
    start();
  }
  function init() { document.querySelectorAll('[data-ca-hero]').forEach(setup); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
